import type { FaireProductEntity } from "../../entity_types/product";

export const p_gu2j3cr4kc: FaireProductEntity = {
  token: "p_gu2j3cr4kc",
  type: "product",
  name: "Starby Squish!",
  brandToken: "b_r7tt2vf93c",
  brandName: "Barefoot Beauties",
  imageUrl:
    "https://cdn.faire.com/fastly/6192440c41dbd9f3b394b4264f6f9e4498e426451be0f76c8677e2bd21db2aab.png",
  galleryImageUrls: [],
  priceDollars: 10,
  description:
    "Get ready to chill out with the coolest toy around, the Starby Squish! This best-selling sensory squish is perfect for stretching, smushing, squeezing, and soothing your way to groovy good vibes. With its super solid squish, it always returns to its square shape, providing endless fun and satisfaction. It’s hip to be square!\n\nColors are randomized.\n\n*Our products are not from Schylling company.\n\nCHOKING HAZARD—Small parts. Not for children under 3 yrs., Do NOT heat, freeze, or microwave, may cause personal injury.",
  tags: [],
  msrpDollars: 20,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:51:32.891Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
